import Vue from 'vue'
import Vuex from 'vuex'
import {enterprise,getOrgcodeData,getRegionNames} from "../api/region.js"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
   //左侧echarts三个图表的公共样式 
   leftAreaChartsStyle: {
      width: '100%',
      minWidth: '400px',
      height: '100%',
      minHeight: '200px',
      maxWidth: '540px',
      pointerEvents: 'all'
    },
   //控制新闻详情栏的淡入淡出, 
   newsFade: false,
   //控制新闻详情栏的数据
   newsInfoData: {},
   regionId:610424   ,//地区ID
   syEnterpriseList:JSON.parse(localStorage.getItem('syEnterpriseList')) || '',//溯源企业列表
   codeData:'',//扫码,赋码数据
   orgIdNum:localStorage.getItem('orgIdNum') || '',//被点击企业的ID
   regionName:'',//地区名称
   videoList:[],//视频直播列表
  },
  mutations: {
    //修改state里newsFade的状态-->展示情况下
    openNewsFade(state) {
      state.newsFade = true;
    },
    //修改state里newsFade的状态-->关闭情况下
    closeNewsFade(state) {
      state.newsFade = false;
    },
    //修改新闻详情栏的数据
    changeNewsData(state,config) {
      console.log(config);
      state.newsInfoData = config;
    },
	//设置溯源企业
	setEnterprise(state,data)
	{
		state.syEnterpriseList = data;
	},
	//设置扫码/赋码值
	setCodeData(state,data)
	{
		state.codeData = data;
	},
	//给企业id赋值
	setOrgIdNum(state,data)
	{
		state.orgIdNum = data;
		localStorage.setItem('orgIdNum',data);	
	},
	//设置地区名称
	setRegionName(state,data)
	{
		state.regionName = !data.orgareaname ? '' : data.orgareaname
	},
	
	//保存视频列表
	saveVideoData(state,data) {
		state.videoList = data;
	}
  },
  actions: {
    //异步的新闻详情页数据,
    changeNewsData({commit},config) {
      commit(changeNewsData,config);
    },
	//获取溯源企业
	getEnterprise({commit}) {
		return new Promise((resolve,reject) => {
			// let userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
				enterprise({
					orgId:10328
				}).then(res => {
					commit('setEnterprise',res.data)
					localStorage.setItem('syEnterpriseList',JSON.stringify(res.data))	
					if(res.code == 0)
					{
						resolve(res.data)
					}
					else
					{
						reject(res.data)
					}
				});
		});
	},
	//获取赋码,扫码数据
	async getCodeData({commit}){
		let result = '';
		let data = this.state.syEnterpriseList;
		if(data != '')
		{
			await data.forEach((item,index) => {
				if(index == data.length-1)
				{
					result += 'orgList=' + item.org_id
				}
				else
				{
					result += 'orgList=' + item.org_id + '&'
				}
			});
			await getOrgcodeData(result).then(res => {
				result = res.data;
				commit('setCodeData',result)
			})
		}
	},
	//获取地区名称
	getRegionNames({commit})
	{
		let Id = this.state.regionId;
		return new Promise((resolve,reject) => {
			getRegionNames(Id).then(res => {
				commit("setRegionName",res.data)
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		});
	}
  },
  getters:{
	orgIdNum:state => state.orgIdNum,
	videoList:state => state.videoList
  },
  modules: {
  }
})
